import { Controller } from "stimulus";
import { debounce } from "../util";

export default class extends Controller {
  static targets = ["widget", "code"];

  connect() {
    this.coinIdChanged = debounce(this._coinIdChanged.bind(this), 800);
    this.currencyChanged = debounce(this._currencyChanged.bind(this), 800);
    this.heightChanged = debounce(this._heightChanged.bind(this), 800);
    this.widthChanged = debounce(this._widthChanged.bind(this), 800);

    // Defaults
    this.currency = "usd";
    this.coinId = "bitcoin";
    this.locale = "en";
    this.height = 300;
    this.width = 0;

    this.updateCode();
  }

  _coinIdChanged(e) {
    this.coinId = e.target.value;
    this.widgetTarget.setAttribute("coin-id", this.coinId);
    this.updateCode();
  }

  _currencyChanged(e) {
    this.currency = e.target.value;
    this.widgetTarget.setAttribute("currency", this.currency);
    this.updateCode();
  }

  _heightChanged(e) {
    this.height = e.target.value;
    this.widgetTarget.setAttribute("height", this.height);
    this.updateCode();
  }

  _widthChanged(e) {
    this.width = e.target.value;
    this.widgetTarget.setAttribute("width", this.width);
    this.updateCode();
  }

  localeChanged(e) {
    this.locale = e.target.value;
    this.widgetTarget.setAttribute("locale", this.locale);
    this.updateCode();
  }

  updateCode() {
    let code = `<script src="https://widgets.coingecko.com/coingecko-coin-price-chart-widget.js"></script>`;
    code += `\n<coingecko-coin-price-chart-widget currency="${this.currency}" coin-id="${
      this.coinId
    }" locale="${this.locale}" height="${this.height}" width="${
      this.width
    }"></coingecko-coin-price-chart-widget>
    `;

    this.codeTarget.textContent = code.trim();
  }
}



// WEBPACK FOOTER //
// ./app/assets/webpack/controllers/price_widget_controller.js